// Item 9 code-review fix: this days-left formula and the reason/tier
// branching used to be duplicated verbatim in AppHeader.js and
// TeamPage.js. Single shared source of truth now backs both — each
// component still owns its own label/color/sentence presentation, since
// those genuinely differ (a short badge vs. a full status sentence).

export function getTrialDaysLeft(plan) {
  if (!plan?.trial_ends_at) return 0;
  return Math.max(0, Math.ceil((new Date(plan.trial_ends_at) - Date.now()) / 86400000));
}

// Item 24: formats current_period_end for display. Short form for the
// header badge ("14 Mar"), long form for TeamPage's status sentence
// ("14 March 2026"). Returns null when the date is unknown — every caller
// must fall back to date-less copy rather than render an empty string.
export function formatPeriodEnd(plan, { long = false } = {}) {
  if (!plan?.current_period_end) return null;
  const d = new Date(plan.current_period_end);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString("en-GB", {
    day: "numeric",
    month: long ? "long" : "short",
    ...(long ? { year: "numeric" } : {}),
  });
}

// "trial" | "dunning_grace" | "free" | "pro_cancelling" | "pro" (paid or
// grandfathered — the two look identical to the end user, so callers don't
// need to tell them apart) | null (no plan data yet, e.g. still loading)
//
// pro_cancelling (item 24): the Billing Portal cancels at period end, so
// Stripe keeps subscription_status 'active' — and the team keeps Pro —
// right up until the period runs out. Without this kind, a user who just
// cancelled sees an unchanged "Pro" and gets no confirmation anywhere in
// the app that it registered. Checked before the plain "pro" fall-through.
export function getPlanStatusKind(plan) {
  if (!plan) return null;
  if (plan.reason === "trial") return "trial";
  if (plan.reason === "dunning_grace") return "dunning_grace";
  if (plan.effective_tier === "free") return "free";
  if (plan.cancel_at_period_end) return "pro_cancelling";
  return "pro";
}
